import React from 'react';
import {useLocation} from "react-router-dom";
import UseContext from "hooks/useContext";

const NavBarTitle = () => {
    const route =useLocation()
    const {pathname}=route
    const path = pathname.split('/')
    const page=path[1]
    const {missionTitle, missionId, language} = UseContext()
    const PAGE ={
        'dashboard':'Tableau de bord',
        'profil':'Paramètres de l\'entreprise',
        'timeSheet':'Relevés d\'heures',
        'files':'Documents',
        'missions':'Missions',
        'contract':'Contrats',
        'invoice':'Factures',
        'personalInformations':'Mon Profil',
        'createOfMission':'Création de missions',
        'activityCompany':'Activités',
        'missionTemplates':'Fiches de postes'
    }
    const isMissionTemplateCreate = pathname.includes('/missionTemplates/create')
    const isMissionTemplateEdit = pathname.includes('/missionTemplates/edit')
    
    // Si on est sur une sous-page de profil, afficher "Paramètres de l'entreprise"
    const isProfilPage = pathname.includes('/profil')
    
    // Si on est sur une page de mission détaillée, afficher le titre de la mission
    const isMissionDetailPage = pathname.includes('/mission/') && pathname !== '/missions'
    
    return (
        <>
            <div className="flex">
                <span className='ft-lg text-gray-700'>
                    {isMissionDetailPage 
                        ? 'Détail de la mission'
                        : isMissionTemplateCreate
                            ? language.getValue('missionTemplate.pageTitle.create', 'Création d\'une fiche de poste')
                            : isMissionTemplateEdit
                            ? language.getValue('missionTemplate.pageTitle.edit', 'Modification d\'une fiche de poste')
                            : isProfilPage 
                                ? 'Paramètres de l\'entreprise' 
                                : (PAGE[page] || '')
                    }
                </span>
            </div>
        </>
    );
};

export default NavBarTitle;